import { IEntityOptionsRepository } from 'src/data/repositories/common/entity-options/entity-options-repository';
import { ILogService } from 'src/data/services/common/log/log-service';
import { CustomError } from 'src/helpers/error/custom-error';
import { EntityOptionRecord } from 'src/data/services/common/entity-options/entity-options-service';

async function executeUseCase<TResponse>(
  logService: ILogService,
  trace: string,
  request: unknown,
  action: () => Promise<TResponse>,
): Promise<TResponse> {
  try {
    await logService.info(`${trace} -> start`);
    await logService.debug(`${trace} -> request`, request);
    return await action();
  } catch (error) {
    throw CustomError.handleError(trace, error);
  } finally {
    await logService.info(`${trace} -> end`);
  }
}

export class LoadEntityOptionsUseCase {
  constructor(
    private logService: ILogService,
    private entityOptionsRepository: IEntityOptionsRepository,
  ) {}

  async handle(entity: string): Promise<EntityOptionRecord[]> {
    return executeUseCase(
      this.logService,
      'LoadEntityOptionsUseCase',
      entity,
      async () => this.entityOptionsRepository.list(entity),
    );
  }
}
